import React from 'react';
import { X, Check, PhoneCall } from 'lucide-react';
import './index.css';

const OrderConfirmationModal = ({ isOpen, onClose, onConfirm, restaurantName, loading, orderType }) => {
  if (!isOpen) return null;

  return (
    <div className="order-confirm-overlay" onClick={() => !loading && onClose()}>
      <div className="order-confirm-modal" onClick={(e) => e.stopPropagation()}>
        <div className="order-confirm-header">
          <div className="order-confirm-icon-wrapper">
            <PhoneCall size={32} className="order-confirm-icon" />
          </div>
          <button
            className="order-confirm-close"
            onClick={onClose}
            disabled={loading}
          >
            <X size={20} />
          </button>
        </div>

        <div className="order-confirm-body">
          <h1 className="order-confirm-title">Order Confirmation</h1>
          <p className="order-confirm-text">
            {orderType === 'collection'
              ? 'Payment details will be confirmed over call.'
              : 'Payment and delivery fees will be confirmed over call. Pay only after confirmation (UPI at dispatch).'}
          </p>

        </div>

        <div className="order-confirm-footer">
          <button
            className="order-confirm-btn-cancel"
            onClick={onClose}
            disabled={loading}
          >
            Cancel
          </button>
          <button
            className="order-confirm-btn-confirm"
            onClick={onConfirm}
            disabled={loading}
          >
            {loading ? (
              <div className="order-confirm-spinner"></div>
            ) : (
              <>
                <Check size={18} />
                <span>Confirm Order</span>
              </>
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default OrderConfirmationModal;
